module.exports = __webpack_public_path__ + "static/img/s12.620ee233.png";